export default __webpack_public_path__ + "media/images/features/ana/head_left-48a066bce7597d7ca925a6f596e6cafa.png";